export const SET_OBTER_RELATORIOS = 'RELATORIOS/SET_OBTER_RELATORIOS'

export const SET_REPROCESSAR_RELATORIO = 'RELATORIOS/SET_REPROCESSAR_RELATORIO'

export const SET_GERAR_RELATORIO = 'RELATORIOS/SET_GERAR_RELATORIO'

export const SET_GERAR_RELATORIO_USU_DELEGACAO = 'RELATORIOS/SET_GERAR_RELATORIO_USU_DELEGACAO'

export const OBTER_CARGOS = 'RELATORIOS/OBTER_CARGOS'

export const OBTER_UNIDADE_LOTACAO = 'RELATORIOS/OBTER_UNIDADE_LOTACAO'

export const OBTER_PATIOS = 'RELATORIOS/OBTER_PATIOS'
